import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=2000&q=80";

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background image */}
      <img
        src={HERO_IMAGE}
        alt="Aspirational learners choosing an education brand"
        className="absolute inset-0 h-full w-full object-cover"
      />
      {/* Deep navy overlay */}
      <div className="absolute inset-0 bg-[#1A2238]/88" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A2238] via-[#1A2238]/40 to-[#1A2238]/70" />

      <motion.div
        variants={stagger}
        initial="hidden"
        animate="show"
        className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center pt-28 pb-16"
      >
        <motion.h1
          variants={fadeUp}
          className="font-display font-extrabold tracking-tighter leading-[1.1] text-4xl sm:text-6xl lg:text-[4.5rem] text-[#FAF7F2] max-w-5xl mx-auto"
        >
          Want to get <span className="hero-pill">Seen</span>,{" "}
          <span className="hero-pill">Trusted</span>, and{" "}
          <span className="hero-pill">Chosen</span>?
        </motion.h1>

       <motion.div
  variants={fadeUp}
  className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5"
>
  {/* Primary Button */}
  <a
    href="https://cal.com/raj-rakshit-ssudkn"
    data-testid="hero-primary-cta"
    className="group inline-flex items-center gap-3 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-base py-2 pl-8 pr-2 rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_36px_rgba(255,106,61,0.45)]"
  >
    Unlock your growth
    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1A2238] text-[#FAF7F2] transition-transform duration-300 group-hover:rotate-45">
      <ArrowUpRight size={20} />
    </span>
  </a>

  {/* Secondary Button */}
  <a
    href="#work"
    data-testid="hero-secondary-cta"
    className="inline-flex items-center gap-3 border border-[#FAF7F2]/30 bg-white/10 backdrop-blur-md text-[#FAF7F2] font-semibold text-base py-4 px-8 rounded-full transition-all duration-300 hover:bg-white hover:text-[#1A2238] hover:border-white"
  >
    See Proof of Work
  </a>
</motion.div>
      </motion.div>
    </section>
  );
};
